/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React from "react";


export default function RegistrationComplete() {

  return (
    <>
      <h2>Registration Success</h2>
      <p>Check your email for an email from us, select the wnclosed link to complete the verification process.</p>
    </>
  );  

};

